module.exports = __webpack_public_path__ + "img/8.bf553cd9.jpg";